import React from 'react'

export default function Card(props) {
    return (
        <div className={`flex items-center justify-between gap-x-5 py-4 px-6 ${props.renk3}`}>
            <div className='gap-y-4'>
                <p className={`${props.renk2}`}>{props.date}</p>
                <h1 className={`text-[16px] lg:text-xl ${props.renk}`}>{props.title}</h1>
                <p className={`t${props.renk2}`}>{props.content}</p>
            </div>
            <div>
                <a className={`${props.renk2}`} href={props.ahref} target="_blank">{props.a}</a>
            </div>
        </div>

    )
}
